import React, { forwardRef } from 'react';
import { Link } from '@atlassian/react-resource-router';
import type { TabBaseProps } from '../../common/types.tsx';

const LinkTab = forwardRef<HTMLButtonElement | HTMLAnchorElement, TabBaseProps>(
	({ children, isDraggable, isDragging, ...props }, ref) => (
		<Link ref={ref} {...props}>
			{children}
		</Link>
	),
);

export default LinkTab;
